import { lazy } from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
} from 'react-router'
import { ErrorPage } from './components/Error'
import NotFound from './pages/NotFound'
import { Root } from './utils/history'
import { ALLOWED_TO_LOGIN, FORCE_CLOSE } from './utils/const'
import RegistrationClosed from './pages/RegistrationClosed'

const Login = lazy(() => import('./pages/Login'))
const Info = lazy(() => import('./pages/forms/Info'))
const General = lazy(() => import('./pages/forms/GeneralQuestion'))
const Major = lazy(() => import('./pages/forms/MajorQuestion'))
const Summary = lazy(() => import('./pages/Summary'))
const Completed = lazy(() => import('./pages/Completed'))
const InterviewAnnouncement = lazy(() =>
  import('./pages/InterviewAnnouncement')
)
const FinalistAnnouncement = lazy(() => import('./pages/FinalistAnnouncement'))

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Root />} errorElement={<ErrorPage />}>
      <Route path="/" element={<Login />} />
      <Route path="/" element={<RequireRegistrationOpen />}>
        <Route path="/step/profile" element={<Info />} />
        <Route path="/step/question" element={<General />} />
        <Route path="/step/major" element={<Major />} />
        <Route path="/step/summary" element={<Summary />} />
        <Route path="/step/submitted" element={<Completed />} />
        <Route
          path="/announcement/interview"
          element={<InterviewAnnouncement />}
        />
        <Route
          path="/announcement/finalist"
          element={<FinalistAnnouncement />}
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Route>
  )
)

function RequireRegistrationOpen() {
  if (ALLOWED_TO_LOGIN && !FORCE_CLOSE) {
    return <Outlet />
  } else {
    return <RegistrationClosed />
  }
}
